export default "__VITE_ASSET__oheU44np__"